import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { heroImage } from '../mock';

const Hero = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 pt-8 md:pt-14 pb-20 md:pb-28">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          <div className="lg:col-span-6 relative animate-fade-up">
            <div className="inline-flex items-center gap-2 bg-white border border-[#1F0068]/10 rounded-full px-3.5 py-1.5 text-xs font-semibold text-[#1F0068] mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF5C39]" />
              UK maintenance service plans — no insurance product
            </div>
            <h1 className="text-[42px] sm:text-6xl lg:text-[76px] leading-[0.98] font-bold tracking-tight text-[#1F0068]">
              When an appliance breaks, <span className="text-[#FF5C39]">we've got a plan for you</span>
            </h1>
            <p className="mt-6 text-lg text-[#1F0068]/70 max-w-lg leading-relaxed">
              Simple monthly or annual maintenance service plans for the appliances, boilers and home systems you rely on — arranged through our network of service providers. These are maintenance service agreements, not insurance products.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link to="/quote">
                <Button className="squircle h-14 px-8 bg-[#1F0068] hover:bg-[#2A0C7A] text-white text-base font-semibold">
                  Protect your appliance <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
              <Link to="/dashboard/new">
                <Button variant="ghost" className="squircle h-14 px-6 text-[#1F0068] hover:bg-white text-base font-semibold">
                  Book a repair
                </Button>
              </Link>
            </div>

          </div>

          <div className="lg:col-span-6 relative">
            <div className="absolute -top-6 -left-6 w-40 h-40 rounded-full blob-1 blur-2xl opacity-70 -z-10" />
            <div className="absolute -bottom-8 -right-8 w-56 h-56 rounded-full bg-[#E8DDFF] blur-2xl opacity-70 -z-10" />

            <div className="relative rounded-[36px] overflow-hidden shadow-2xl aspect-[5/4]">
              <img src={heroImage} alt="Young couple in modern kitchen" className="w-full h-full object-cover" />
            </div>

            <div className="absolute -bottom-6 left-4 md:-left-6 bg-white rounded-2xl shadow-xl px-5 py-4 flex items-center gap-3 max-w-[280px]">
              <div className="w-11 h-11 rounded-xl bg-[#FF5C39]/10 flex items-center justify-center">
                <span className="text-[#FF5C39] font-extrabold">£</span>
              </div>
              <div>
                <div className="text-xs text-[#1F0068]/60">Simple pricing</div>
                <div className="text-sm font-bold text-[#1F0068]">Monthly or annual</div>
              </div>
            </div>

            <div className="absolute -top-4 right-4 md:-right-4 bg-white rounded-2xl shadow-xl px-4 py-3 hidden sm:flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#1F0068] text-white flex items-center justify-center font-bold text-sm">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
              </div>
              <div>
                <div className="text-[11px] text-[#1F0068]/60">UK-based team</div>
                <div className="text-sm font-bold text-[#1F0068]">Mon–Fri, 9am–5pm</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
